import { ContentIcons, SystemIcons } from "@laerdal/life-react-components";

export const caseTypeSubtypes = [
    {
        value: 'technical',
        title: 'Technical Support and Troubleshooting', 
        subtitle: 'Let us know if you’re having trouble with a product or need help with technical issues.', 
        icon: <ContentIcons.Maintenance size="24px"/>,
        subtypes: [{
            value: 'productDoesNotWork',
            title: 'My product does not work',
            caseType: 'product support',
            caseSubtype: 'product functionality',
            howCanWeHelp: 'My product does not work',
            caseSubject: 'My product does not work',
            skipAssetSelection: false,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: true,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'technicalSupport',
            title: 'I need technical support',
            caseType: 'product support',
            caseSubtype: 'Guidance',
            howCanWeHelp: 'I need technical support',
            caseSubject: 'I need technical support',
            skipAssetSelection: false,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'assetMissing',
            title: 'Asset is missing or incorrect',
            caseType: 'Process support',
            caseSubtype: 'Product',
            howCanWeHelp: 'Asset is missing or incorrect',
            caseSubject: 'Asset is missing or incorrect',
            skipAssetSelection: true,
            accountNumberRequired: true,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'guidance',
            title: 'I need help regarding my product',
            caseType: 'product support',
            caseSubtype: 'Guidance',
            howCanWeHelp: 'I need some guidance',
            caseSubject: 'I need some guidance',
            skipAssetSelection: false,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'connect',
            title: 'Requesting access to the Laerdal Connect dashboard',
            caseType: 'quick case',
            caseSubtype: null,
            howCanWeHelp: 'Requesting access to the Laerdal Connect dashboard',
            caseSubject: 'Requesting access to the Laerdal Connect dashboard',
            skipAssetSelection: true,
            accountNumberRequired: true,
            accountNumberVisible: true,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'simcapture',
            title: 'I need support with SimCapture',
            caseType: 'SimCapture Support', 
            caseSubtype: null,
            howCanWeHelp: 'SimCapture Cases from the SimCapture page',
            caseSubject: 'SimCapture Cases from the SimCapture page',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         }]
    },
    {
        value: 'billing',
        title: 'Orders and Billing', 
        subtitle: 'Have a question about purchases, payments, or account details?', 
        icon: <ContentIcons.Note size="24px"/>,
        subtypes: [{
            value: 'orderOrInvoice',
            title: 'I have a question about an order or invoice',
            caseType: 'Quick case',
            caseSubtype: 'order',
            howCanWeHelp: 'I have a question about an order or invoice',
            caseSubject: 'I have a question about an order or invoice',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: true,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'moreInformation',
            title: 'Request more information',
            caseType: 'quick case',
            caseSubtype: 'Basic question',
            howCanWeHelp: 'I want to request more information',
            caseSubject: 'I want to request more information',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: true,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'qoute',
            title: 'I want to get a quote',
            caseType: 'sales support',
            caseSubtype: 'quote',
            howCanWeHelp: 'I want to get a quote',
            caseSubject: 'I want to get a quote',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'updateAccount',
            title: 'I wish to update account or billing information',
            caseType: 'Finance support',
            caseSubtype: null,
            howCanWeHelp: 'I wish to update account or billing information',
            caseSubject: 'I wish to update account or billing information',
            skipAssetSelection: true,
            accountNumberRequired: true,
            accountNumberVisible: true,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: true,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },
         {
            value: 'revokeAhaLicense',
            title: 'I want to revoke an AHA license',
            caseType: 'RQI support',
            caseSubtype: 'Product functionality',
            howCanWeHelp: 'I want to revoke an AHA license',
            caseSubject: 'I want to revoke an AHA license',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: false,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: true,
            llpOrganizationNameVisible: true,
            creationDateLicenseVisible:true,
            productVisible:true,
            organizationTypeRequired: true,
         }
      ]
    },
    {
        value: 'return',
        title: 'Return', 
        subtitle: 'Need for returning a new purchased product?', 
        icon: <ContentIcons.Stock size="24px"/>,
        subtypes: [{
            value: 'initiateReturn',
            title: 'I want to initiate a return',
            caseType: 'Process support',
            caseSubtype: 'Return',
            howCanWeHelp: 'I wish to initiate a return',
            caseSubject: 'I wish to initiate a return',
            skipAssetSelection: true,
            accountNumberRequired: true,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: true,
            returnReasonVisible: true,
            orderNumberVisible: true,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         }]
    },
    {
        value: 'general',
        title: 'General Requests', 
        subtitle: 'Can’t find what you’re looking for? Reach out, and we’ll get back to you.', 
        icon: <ContentIcons.Information size="24px"/>,
        subtypes: [{
            value: 'questionAboutProduct',
            title: 'I have a question about a product or service',
            caseType: 'Product support',
            caseSubtype: 'Guidance',
            howCanWeHelp: 'I have a question about a product or service',
            caseSubject: 'I have a question about a product or service',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: false,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'contactMe',
            title: 'I want to be contacted',
            caseType: 'quick case',
            caseSubtype: null,
            howCanWeHelp: 'I want to be contacted',
            caseSubject: 'I want to be contacted',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         }]
    },
    {
        value: 'privacy',
        title: 'Data Privacy and Security', 
        subtitle: 'Report any privacy, security, or vulnerability issue you’ve encountered with our products.', 
        icon: <ContentIcons.CloudLocked size="24px"/>,
        subtypes: [{
            value: 'privacyIssue',
            title: 'I have a data privacy issue or concern',
            caseType: 'Quick case',
            caseSubtype: null,
            howCanWeHelp: 'I have a data privacy issue or concern',
            caseSubject: 'I have a data privacy issue or concern',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: false,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'securityIssue',
            title: 'I have a security issue or concern',
            caseType: 'Quick case',
            caseSubtype: null,
            howCanWeHelp: 'I have a security issue or concern',
            caseSubject: 'I have a security issue or concern',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: false,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
         },{
            value: 'dataBreach',
            title: 'I have identified a potential data breach',
            caseType: 'Quick case',
            caseSubtype: null,
            howCanWeHelp: 'I have identified a potential data breach',
            caseSubject: 'I have identified a potential data breach',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: false,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'vulnerability',
            title: 'I have identified a vulnerability in a Laerdal-supplied software',
            caseType: 'Quick case',
            caseSubtype: null,
            howCanWeHelp: 'I have identified a vulnerability in a Laerdal supplied software',
            caseSubject: 'I have identified a vulnerability in a Laerdal supplied software',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: false,
            productNameVisible: false,
            productNameRequired: false,
            serialNumberVisible: false,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         },{
            value: 'patientSafety',
            title: 'I have a concern about patient safety or involvement',
            caseType: 'product support',
            caseSubtype: 'product functionality',
            howCanWeHelp: 'I have identified a patient involvement',
            caseSubject: 'I have identified a patient involvement',
            skipAssetSelection: true,
            accountNumberRequired: false,
            accountNumberVisible: true,
            productNameVisible: true,
            productNameRequired: true,
            serialNumberVisible: true,
            returnReasonVisible: false,
            orderNumberVisible: false,
            llpOrganizationIDVisible: false,
            llpOrganizationNameVisible: false,
            creationDateLicenseVisible: false,
            productVisible:   false,
            organizationTypeRequired: false,
         }]
    }
]